<template>
  <page>
    <span slot="page-title">About</span>
    <p>The 2022 U.S. Senate and House forecasts were developed and are maintained by DecisionDeskHQ.</p>
    <p>The model on the website is the public version and includes all reputable and available public polling. Decision Desk HQ advises non-partisan, private clients on legislative risk and in those instances a private version of the models are utilized that contains client specific datasets, including private polling.</p>
    <p>The data were retrieved from public sources where appropriate and the privately sourced data is derived from Decision Desk HQ's access to political, economic and demographic data sets at the national, state and district level. More information can be found on our <a @click="$router.push('/methodology')">methodology</a> page.</p>
    <p>Think you have a smart angle we're missing? Just like this stuff in general? Want to come work at a cool place? Reach out and tell us.</p>

    <div class="social-links mb-4">
      <p class="mb-2">Connect with Decision Desk HQ:</p>
      <p>Email: <a href="mailto:info@decisiondeskhq.com">info@decisiondeskhq.com</a></p>
      <p>Editorial: <a href="https://decisiondeskhq.com">decisiondeskhq.com</a></p>
      <p>Business: <a href="https://ddhq.io">ddhq.io</a></p>
      <p>Twitter: <a href="https://twitter.com/DecisionDeskHQ" target="_blank">@DecisionDeskHQ</a></p>
      <p>Facebook: <a href="https://facebook.com/DecisionDeskHQ" target="_blank">facebook.com/DecisionDeskHQ</a></p>
      <p>YouTube: <a href="https://youtube.com/c/DecisionDeskHQOfficial" target="_blank">youtube.com/c/DecisionDeskHQOfficial</a></p>
    </div>
  </page>
</template>

<script>
import { Page } from '@/components'

const name = 'about'

const components = {
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'About',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'About'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'About'
      }, {
        vmid: 'description',
        name: 'description',
        content: 'The Descision Desk HQ forecasting model was created and maintained by Scott Tranter (partner) of Decision Desk HQ and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Decision Desk HQ data science team.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: 'The Descision Desk HQ forecasting model was created and maintained by Scott Tranter (partner) of Decision Desk HQ and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Decision Desk HQ data science team.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: 'The Descision Desk HQ forecasting model was created and maintained by Scott Tranter (partner) of Decision Desk HQ and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Decision Desk HQ data science team.'
      }
    ]
  }
}
</script>

<style scoped>
.social-links p {
  margin: 0;
}
</style>
